import React from 'react';
import { useTranslation } from 'react-i18next';

const ConsumablePropertiesForm = ({ editData, onFieldChange, disabled = false }) => {
  const { t } = useTranslation('warehouse');
  const handleFieldChange = (field, value) => {
    onFieldChange(field, value);
  };

  return (
    <div className="form-section">
      <h3>{t('consumablePropertiesForm.title')}</h3>
      <div className="form-grid">
        <div className="form-group">
          <label>{t('consumablePropertiesForm.consumableType')}</label>
          <select
            value={editData.consumable_type || ''}
            onChange={(e) => handleFieldChange('consumable_type', e.target.value)}
            disabled={disabled}
          >
            <option value="" disabled hidden>{t('consumablePropertiesForm.selectConsumableType')}</option>
            <option value="CLEANING">{t('consumablePropertiesForm.types.CLEANING')}</option>
            <option value="MAINTENANCE">{t('consumablePropertiesForm.types.MAINTENANCE')}</option>
            <option value="TOOLING">{t('consumablePropertiesForm.types.TOOLING')}</option>
            <option value="ADHESIVE">{t('consumablePropertiesForm.types.ADHESIVE')}</option>
            <option value="OTHER">{t('consumablePropertiesForm.types.OTHER')}</option>
          </select>
        </div>

        <div className="form-group">
          <label>{t('consumablePropertiesForm.usageRate')}</label>
          <input
            type="number"
            step="0.0001"
            value={editData.usage_rate_per_hour || ''}
            onChange={(e) => handleFieldChange('usage_rate_per_hour', parseFloat(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('consumablePropertiesForm.usageRatePlaceholder')}
          />
        </div>

        <div className="form-group">
          <label>{t('consumablePropertiesForm.replacementFrequency')}</label>
          <input
            type="number"
            value={editData.replacement_frequency_hours || ''}
            onChange={(e) => handleFieldChange('replacement_frequency_hours', parseInt(e.target.value) || null)}
            disabled={disabled}
            placeholder={t('consumablePropertiesForm.replacementFrequencyPlaceholder')}
          />
        </div>

        <div className="form-group">
          <label>{t('consumablePropertiesForm.safetyInformation')}</label>
          <div className="checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={editData.hazardous || false}
                onChange={(e) => handleFieldChange('hazardous', e.target.checked)}
                disabled={disabled}
              />
              {t('consumablePropertiesForm.hazardous')}
            </label>
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={editData.msds_available || false}
                onChange={(e) => handleFieldChange('msds_available', e.target.checked)}
                disabled={disabled}
              />
              {t('consumablePropertiesForm.msdsAvailable')}
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsumablePropertiesForm;